<template>
    <div class="n2oconcentration">
        <table>
            <tr>
                <td class="left">
                    <label >N<sub>2</sub>O {{type}}</label>
                </td>

                <td class="result">
                    <label >{{concentration}} {{units}}</label>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
  /* eslint-disable */
    name: 'n2oconcentration',
    props: {
        gasConcentration: Number,
        gasConcentrationType: String,
        pressure: Number,
        pressureType: String,
        salinity: Number,
        salinityType: String,
        temp: Number,
        tempType: String,
        unit: String,
        triggerprop: Number,
        obj: Object
    },
    data: () => ({
        concentration: 0,
        units: "\u03BCmol",
        unitsn2o: [
            "\u03BCmol/L",
            "mm Hg",
            "mBar",
            "%",
            "ppm (vol/vol)",
            "ppm (mg/L)",
            "mg N/L"
        ],
        type: "Concentration:"
    }),
    methods: {
        calculate(){
            var temp
            var pressure
            var sal
            var gasconc
            var conc
            if (this.obj.tempType === "Kelvin") {
                temp = Number(this.obj.temp) - 273.15
            } else {
                temp = Number(this.obj.temp)
            }
            pressure = Number(this.obj.pressure)
            sal = Number(this.obj.salinity)
            gasconc = Number(this.obj.gasConcentration)
            switch(this.unit) {
                case "\u03BCmol/L":
                    this.units = "\u03BCmol/L"
                    conc = this.umolL(temp, sal, pressure, gasconc)
                    this.type = "Concentration:"
                    break;
                case "mg N/L":
                    this.units = "mg N/L"
                    conc = this.NmgmL(temp,sal,pressure,gasconc)
                    this.type = "Concentration:"
                    break;
                case "%":
                    this.units = "%"
                    conc = this.saturation(temp,sal,pressure,gasconc)
                    this.type = "Concentration:"
                    break;
                case "ppm (vol/vol)":
                    this.units = "ppm (vol/vol)"
                    conc = this.ppm(temp,sal,pressure,gasconc)
                    this.type = "Concentration:"
                    break;
                case "mBar":
                    this.units = "mBar"
                    conc = this.mBar(temp,sal,pressure,gasconc)
                    this.type = "Partial Pressure:"
                    break;
                case "mm Hg":
                    this.units = "mm Hg"
                    conc = this.mmHg(temp, sal, pressure, gasconc)
                    this.type = "Partial Pressure:"
                    break;
                case "ppm (mg/L)":
                    this.units = "ppm (mg/L)"
                    conc = this.ppmmgL(temp,sal,pressure,gasconc)
                    this.type = "Concentration:"
                    break;
                default:
                    this.units = "N/A"
                    conc = 0;
                    this.type = ""
                    break;
            }
            this.concentration = conc.toPrecision(6)
        },
        K(temp, sal){
          var T0 = 273.15
          var constA1 = -62.70620000
          var constA2 = 97.30660000
          var constA3 = 24.14060000
          var constB1 = -0.05842000
          var constB2 = 0.03319300
          var constB3 = -0.00513130
          var absTemp = temp + T0
          var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
          var ptable = 1 * (1013.25 - p_sat)

          var t = Math.exp(constA1 + constA2 * (100 / absTemp) + constA3 * Math.log(absTemp / 100) + sal * (constB1 + constB2 * (absTemp / 100) + constB3 * Math.pow((absTemp / 100), 2))) * 1000000
          return t/ptable
        },
        umolL(temp, sal, pressure, gasconc){
          switch(this.obj.unitIn){
            case "\u03BCmol/L":
              return gasconc
            case "ppm (mg/L)":
              return gasconc*1000/44.013
            case "mm Hg":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              return this.K(temp, sal)*gasconc/0.750061683
            case "%":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var pres = (pressure - p_sat) * gasconc / 100
              return this.K(temp, sal)*pres
            case "mBar":
              return this.K(temp, sal)*gasconc
            case "ppm (vol/vol)":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var pres = (pressure - p_sat) * gasconc / 1000000
              return this.K(temp, sal)*pres
            case "mg N/L":
              return gasconc/0.0280134
          }
        },
        mmHg(temp, sal, pressure, gasconc){
          switch(this.obj.unitIn){
            case "\u03BCmol/L":
              return(gasconc/this.K(temp, sal))*0.750061683
            case "ppm (mg/L)":
              var conc = gasconc*1000/44.013
              return(conc/this.K(temp, sal))*0.750061683
            case "mm Hg":
              return gasconc
            case "%":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var partpres = (pressure - p_sat) * gasconc / 100
              return partpres * 0.750061683
            case "mBar":
              return gasconc * 0.750061683
            case "ppm (vol/vol)":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var partpres = (pressure - p_sat) * gasconc / 1000000
              return partpres * 0.750061683
            case "mg N/L":
              var conc = gasconc/0.0280134
              return(conc/this.K(temp, sal))*0.750061683
          }
        },
        saturation(temp, sal, pressure, gasconc){
          switch(this.obj.unitIn){
            case "\u03BCmol/L":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var pres = gasconc/this.K(temp, sal)
              return pres*100/(pressure-p_sat)
            case "ppm (mg/L)":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var conc = gasconc*1000/44.013
              var pres = conc/this.K(temp, sal)
              return pres*100/(pressure-p_sat)
            case "mm Hg":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              return gasconc/0.750061683*100/(pressure-p_sat)
            case "%":
              return gasconc
            case "mBar":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              return gasconc*100/(pressure-p_sat)
            case "ppm (vol/vol)":
              return gasconc/10000
            case "mg N/L":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var conc =gasconc/0.0280134
              var pres = conc/this.K(temp, sal)
              return pres*100/(pressure-p_sat)
          }
        },
        mBar(temp, sal, pressure, gasconc){
          switch(this.obj.unitIn){
            case "\u03BCmol/L":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              return(gasconc/this.K(temp, sal))
            case "ppm (mg/L)":
              var conc = gasconc*1000/44.013
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              return(conc/this.K(temp, sal))
            case "mm Hg":
              return gasconc/0.750061683
            case "%":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var partpres = (pressure - p_sat) * gasconc / 100
              return partpres
            case "mBar":
              return gasconc
            case "ppm (vol/vol)":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var partpres = (pressure - p_sat) * gasconc / 1000000
              return partpres
            case "mg N/L":
              var conc = gasconc/0.0280134
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              return(conc/this.K(temp, sal))
          }
        },
        ppm(temp, sal, pressure, gasconc){
          switch(this.obj.unitIn){
            case "\u03BCmol/L":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var pres = gasconc/this.K(temp, sal)
              return pres*1000000/(pressure-p_sat)
            case "ppm (mg/L)":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var conc = gasconc*1000/44.013
              var pres = conc/this.K(temp, sal)
              return pres*1000000/(pressure-p_sat)
            case "mm Hg":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              return gasconc/0.750061683*1000000/(pressure-p_sat)
            case "%":
              return gasconc*10000
            case "mBar":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              return gasconc*1000000/(pressure-p_sat)
            case "ppm (vol/vol)":
              return gasconc
            case "mg N/L":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var conc = gasconc / 0.0280134
              var pres = conc / this.K(temp, sal)
              return pres * 1000000 / (pressure - p_sat)
          }
        },
        ppmmgL(temp, sal, pressure, gasconc){
          switch(this.obj.unitIn){
            case "\u03BCmol/L":
              return gasconc * 44.013/1000
              break;
            case "ppm (mg/L)":
              return gasconc
              break;
            case "mm Hg":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              return this.K(temp, sal)*gasconc/0.750061683*44.013/1000
              break;
            case "%":
              var pres = gasconc*pressure
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var pres = (pressure - p_sat) * gasconc / 100
              return this.K(temp, sal)*pres*44.013/1000
              break;
            case "mBar":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              return this.K(temp, sal)*gasconc*44.013/1000
              break;
            case "ppm (vol/vol)":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var pres = (pressure - p_sat) * gasconc / 1000000
              return this.K(temp, sal)*pres*44.013/1000
              break;
            case "mg N/L":
              return gasconc/0.0280134*44.013/1000
              break;
          }
        },
        NmgmL(temp, sal, pressure, gasconc){
          switch(this.obj.unitIn){
            case "\u03BCmol/L":
              return gasconc*0.0280134
            case "ppm (mg/L)":
              return gasconc*1000/44.013*0.0280134
            case "mm Hg":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              return this.K(temp, sal)*gasconc/0.750061683*0.0280134
            case "%":
              var pres = gasconc*pressure
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var pres = (pressure - p_sat) * gasconc / 100
              return this.K(temp, sal)*pres*0.0280134
            case "mBar":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              return this.K(temp, sal)*gasconc*0.0280134
            case "ppm (vol/vol)":
              var T0 = 273.15
              var p_sat = Math.exp((52.57 - (6690.9 / (temp + T0))) - 4.681 * Math.log(temp + T0))
              var pres = (pressure - p_sat) * gasconc / 1000000
              return this.K(temp, sal)*pres*0.0280134
            case "mg N/L":
              return gasconc
          }
        }
    },
    mounted () {
        this.calculate()
    },
    watch: {
        triggerprop: function(newval, oldval) {
            this.calculate()
        }
    }
}
</script>
